import { ICustomCellRendererParams } from "@ts/common-types";
import { internationalizeNumericValue } from "@ts/utils";

const AlertsCellRenderer = (params: ICustomCellRendererParams) => {
    if (params.node.rowPinned) {
        return null;
    }
    const rowData = params.data[params.column.colId];
    const parsedData = parseFloat(rowData);
    const formattedInput = isNaN(parsedData)
        ? rowData
        : internationalizeNumericValue(parsedData % 1 === 0
            ? parseInt(rowData)
            : parsedData.toFixed(1));
    return (
        <>
            {params.node.rowPinned ? null : (
                <div
                >
                    {formattedInput}
                </div>
            )}
        </>
    );
};

export default AlertsCellRenderer;
